import { useCallback, useRef, useState } from 'react';
import ConfirmationDialog from '../../../Components/Shared/ConfirmationDialog/ConfirmationDialog';
import { useSectionDispatchContext } from '@app/Areas/Optimus/State/DataStores/ResourceStore/ResourceContextProvider/ResourceContextProvider';
import { RESOURCES_CLEAR_GROUP_UNDER_DELETE, getVaultSectionGroups } from '../../../State/DataStores/ResourceStore/ResourceReducer/ResourceReducer';
import useVaultsAsDictionary from '@app/Areas/Optimus/State/DataStores/VaultStore/hooks/useVaultsAsDictionary';
import createGroupService from '../../../Services/GroupService/GroupService';
import useGroupUnderDelete from '../../../State/DataStores/ResourceStore/hooks/useGroupUnderDelete/useGroupUnderDelete';
import { DELETE_GROUP_DIALOG_ID } from '../../ActionDialogs/index';

function DeleteGroup() {
    const parsedGroupToDelete = useGroupUnderDelete();
    const groupUnderDelete = parsedGroupToDelete?.group;
    const vaults = useVaultsAsDictionary();
    const currentParentVaultId = parsedGroupToDelete?.parentVaultId;
    const currentParentSectionId = parsedGroupToDelete?.parentSectionId;
    const currentParentVault = currentParentVaultId ? vaults[currentParentVaultId] : null;
    const [isSending, setIsSending] = useState(false);
    const groupService = createGroupService();
    const groupDispatch = useSectionDispatchContext();
    const isMounted = useRef(true);

    const sendRequest = useCallback(async (callback) => {
        if (currentParentVaultId && currentParentSectionId && parsedGroupToDelete?.group.id) {
            // don't send again while we are sending
            if (isSending) return
            // update state
            setIsSending(true)
            // send the actual request
            try {
                await groupService.archiveGroup(currentParentVaultId, currentParentSectionId, parsedGroupToDelete?.group.id); // TODO: Fix server response
                groupDispatch(getVaultSectionGroups(currentParentVaultId, currentParentSectionId, false));
                callback();   
            } catch {}
            finally {
                // once the request is sent, update state again
                if (isMounted.current) { // only update if we are still mounted
                    setIsSending(false)
                }
            }
        }
      }, [currentParentVault, parsedGroupToDelete, isSending]
    ); // update the callback if the state changes

    const handleConfirm = (callback: () => void) => {
        if (!isSending) {
            sendRequest(callback);
        }
    }

    const cleanUp = () => {
        groupDispatch({
            type: RESOURCES_CLEAR_GROUP_UNDER_DELETE
        })
    }

    return currentParentVault && groupUnderDelete && (
        <ConfirmationDialog
            title="Delete Group"
            description={`Are you sure you want to delete the group '${groupUnderDelete.name}' and all of its resources?`}
            dialogId={DELETE_GROUP_DIALOG_ID}
            onConfirm={handleConfirm}
            onClose={cleanUp}
        />
    ) || null;
}

export default DeleteGroup;
